<template>
    <div class="either-or-filter">
        <div class="field has-addons">
            <p v-for="option in filter.options" :key="option.value" class="control">
                <e-button
                    :class="{
                        'is-active': filter.isActiveChoice(option),
                    }"
                    @click="handleOptionClick(option.value)"
                >
                    {{ option.label }}
                </e-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EitherOrFilterItem',

    props: {
        filter: {
            type: Object,
            required: true,
        },
        applyFilter: {
            type: Function,
            required: true,
        },
    },

    methods: {
        handleOptionClick(value) {
            this.applyFilter(this.filter, value);
        },
    },
};
</script>
